import { render, staticRenderFns } from "./EditMaterialPopup.vue?vue&type=template&id=4e1272b7"
import script from "./EditMaterialPopup.vue?vue&type=script&lang=js"
export * from "./EditMaterialPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports